// sandbox： 测试 ； prod: 生产
export default process.env.REACT_APP_SERVER_ENV